import APIController from '../api/APIController'

const useAPI = () => {
    return APIController
}

export default useAPI;